import { render, staticRenderFns } from "./RadioItem.vue?vue&type=template&id=5e8e6d6e&"
import script from "./RadioItem.vue?vue&type=script&lang=js&"
export * from "./RadioItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports